import axiosInstance from "../../utils/axiosInstance";

const getChallenges = async (params) => {
  console.log(params);
  const response = await axiosInstance.get(`challenge?limit=${params.pageSize}&skip=${(params.current - 1) * params.pageSize}&key=${params.key}&status=${params.status}&type=${params.type}`);
  return response.data.data;
};

const getChallenge = async (id) => {
  const response = await axiosInstance.get(`challenge/${id}`);
  return response.data.data;
};

const createChallenge = async (data) => {
  const response = await axiosInstance.post(`challenge`, data);
  return response.data.data;
};

const updateChallenge = async (params) => {
  const response = await axiosInstance.put(`challenge/${params.id}`, params.data);
  return response.data.data;
};

const deleteChallenge = async (params) => {
  const response = await axiosInstance.delete(`challenge/${params.id}`);
  return response.data.data;
};

const refreshChallenge = async (data) => {
  const response = await axiosInstance.post(`challenge/refresh`, data);
  return response.data.data;
};

const updateChallengeStatus = async (params) => {
  const response = await axiosInstance.put(`challenge/${params.id}`, params.data);
  return response.data.data;
};

const getChallengeEntries = async (params) => {
  const response = await axiosInstance.get(`challenge/entries?limit=${params.pageSize}&skip=${(params.current - 1) * params.pageSize}&status=${params.status}&type=${params.type}&key=${params.key}`);
  return response.data.data;
};

const approvedChallengeEntry = async (params) => {
  const response = await axiosInstance.post(`challenge/entries/approve`, params);
  return response.data.data;
};

const rejectChallengeEntry = async (params) => {
  const response = await axiosInstance.post(`challenge/entries/reject`, params);
  return response.data.data;
};

const getChallengeEntry = async (params) => {
  const response = await axiosInstance.get(`challenge/entries/${params}`);
  return response.data.data;
};

const updateChallengeEntry = async (params) => {
  const response = await axiosInstance.put(`challenge/entries/${params.id}`, params.data);
  return response.data.data;
};

const addToFeedChallengeEntry = async (params) => {
  const response = await axiosInstance.post(`challenge/entries/add-to-feed`, params);
  return response.data.data;
};

const removeFromFeedChallengeEntry = async (params) => {
  const response = await axiosInstance.post(`challenge/entries/remove-from-feed`, params);
  return response.data.data;
};

const challengeService = {
  getChallenges,
  updateChallenge,
  createChallenge,
  updateChallengeStatus,
  getChallenge,
  deleteChallenge,
  refreshChallenge,
  getChallengeEntries,
  approvedChallengeEntry,
  rejectChallengeEntry,
  getChallengeEntry,
  updateChallengeEntry,
  addToFeedChallengeEntry,
  removeFromFeedChallengeEntry,
};

export default challengeService;
